module.exports = __webpack_public_path__ + "img/youxiuchuangzuozhe.71824d8a.png";